<template>
  <sdui-login :show-arrow="false">
    <main class="d-flex justify-content-center align-items-center v-full-height">
      <b-container>
        <div class="d-flex justify-content-center align-items-center mb-5" :class="{ 'mt-5': brandingConfig.start.image }">
          <img
            class="img-fluid-branded-logo"
            :src="getImage(brandingConfig.logos.logo)"
            alt=""
            :data-cy="`${branding}-login-logo`"
            loading="lazy"
          />
        </div>

        <div v-if="brandingConfig.start.image" class="d-flex justify-content-center align-items-center mb-5">
          <img :src="brandingConfig.start.image"
               class="img-fluid img-max-md"
               alt=""
          />
        </div>

        <div v-if="showSampleSchool" class="d-flex justify-content-center align-items-center p-5">
          <div class="w-50 mr-1">
            <b-button
              appearance="b-button"
              variant="secondary"
              data-cy="sample-school"
              block
              @click="$router.push({ name: 'cypress-sample-schools-generation' })"
            >
              <span lang="en">Sample Schools</span>
            </b-button>
          </div>

          <div class="w-50 ml-1">
            <b-button variant="secondary"
                      data-cy="sample-school"
                      block
                      @click="showEnvironments = true"
            >
              <span lang="en">Environments</span>
            </b-button>
          </div>
        </div>

        <div class="text-center text-sdui mb-5">
          <h1 class="h3 mb-3" data-cy="start-screen-title">
            {{ $t('public.start.welcome') }}
          </h1>

          <p class="mb-3">
            {{ $t(brandingConfig.start.description) }}
          </p>

          <SLink v-if="brandingConfig.start.show_more"
                 appearance="b-link"
                 :href="$t('public.start.more.href')"
          >
            <span aria-hidden="true">{{ $t('public.start.more.text') }}</span>
            <span class="sr-only">{{ $t('public.start.more.text') }} {{ $t('accessibility.about') }} {{ $t('global.app_name') }}</span>
          </SLink>
        </div>

        <div class="text-center pb-5">
          <b-button
            size="lg"
            variant="primary"
            data-cy="search-school"
            class="btn-start align-content-center"
            @click="$router.push({ name: 'login-select-school' })"
          >
            {{ brandingConfig.start.sdui_authenticator ? $t('public.start.to_messenger') : $t('public.start.school_search') }}
          </b-button>
        </div>
        <template v-if="brandingConfig.start.sdui_authenticator">
          <sdui-labeled-divider :divider-word="$t('login.login_sign_in.separator')" class="pb-5" />
          <div class="text-center pb-4">
            <b-button
              size="lg"
              variant="primary"
              data-cy="to-authenticator"
              class="btn-start align-content-center"
              @click="$router.push({ name: 'authenticator-start' })"
            >
              {{ $t('public.start.to_authenticator') }}
            </b-button>
          </div>
        </template>
      </b-container>
    </main>
    <SModal v-model="showEnvironments"
            :header-title="$t('development.choose_environment')"
            hide-footer
    >
      <switch-environment v-if="showEnvironments" />
    </SModal>
  </sdui-login>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import SduiLabeledDivider from 'src/components/miscellaneous/ui/SduiLabeledDivider.vue'
import SduiLogin from 'src/layout/SduiLogin.vue'
import brandingMixin from 'src/mixins/branding/brandingMixin.js'

export default {
  name: 'Start',
  components: {
    SwitchEnvironment: defineAsyncComponent(() => import('src/components/management/SwitchEnvironment.vue')),
    SduiLogin,
    SduiLabeledDivider,
  },

  mixins: [brandingMixin],
  data: () => ({
    show: false,
    slide: 0,
    showEnvironments: false,
  }),

  computed: {
    showSampleSchool() {
      return JSON.parse(import.meta.env.VITE_SAMPLE_SCHOOLS || 'false')
    },
  },

  methods: {},
}
</script>

<style scoped lang="scss">
.text-sdui {
  max-width: 340px;
  margin: 0 auto;
  display: block;
  font-weight: $font-weight-bold;
}

.sdui-image {
  @media (min-width: 700px) {
    width: 50%;
    margin: 0 auto;
    padding-top: 50px;
  }

  @media (max-width: 320px) {
    width: 70%;
    margin: 0 auto;
  }
}

.btn-start {
  min-width: 250px !important;
  border-radius: 8px;
}

.all-png {
  width: 75%;
  height: 75%;
  @media (min-width: 700px) {
    height: 50%;
    width: 50%;
  }
}

.v-full-height {
  min-height: 100vh;
}
</style>
